<template>
  <div class="hold-transition">
    <div class="wrapper">
      <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Remolques</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/Admin">Administrativo</router-link>
                  </li>
                  <li class="breadcrumb-item active">General</li>
                  <li class="breadcrumb-item active">Remolques</li>
                </ol>
              </div>
            </div>
          </div>
          <!-- /.container-fluid -->
        </section>
        <!-- Main content -->
        <section class="content">
          <div class="container-fluid">
            <!-- Header con botones de acción -->
            <div class="row">
              <div class="col-12">
                <div class="card shadow-sm border-0" :class="$store.getters.getDarkMode ? 'bg-dark' : 'bg-white'">
                  <div class="card-body py-3">
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <h4 class="mb-0" :class="$store.getters.getDarkMode ? 'text-light' : 'text-dark'">
                          <i class="fas fa-truck me-2 text-primary"></i>
                          Gestión de Remolques
                        </h4>
                        <p class="text-muted mb-0 small">Administra y visualiza todos los remolques del sistema</p>
                      </div>
                      <div class="btn-group" role="group">
                        <button type="button" class="btn btn-outline-info" @click="pivotTable()"
                          v-if="$store.getters.can('admin.remolques.pivotTable')" data-bs-toggle="tooltip"
                          title="Vista de tabla dinámica">
                          <i class="fas fa-scroll me-1"></i>
                          Tabla Dinámica
                        </button>
                        <button type="button" class="btn btn-outline-success" data-toggle="modal"
                          data-target="#modal_form_remolque_export" v-if="$store.getters.can('admin.remolques.export')"
                          data-bs-toggle="tooltip" title="Exportar a Excel">
                          <i class="far fa-file-excel me-1"></i>
                          Exportar
                        </button>
                        <button type="button" class="btn btn-primary"
                          v-if="$store.getters.can('admin.remolques.create')" @click="create()" data-bs-toggle="tooltip"
                          title="Crear nuevo remolque">
                          <i class="fas fa-plus me-1"></i>
                          Nuevo Remolque
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Sección de filtros -->
            <div class="row">
              <div class="col-12">
                <div class="card" :class="$store.getters.getDarkMode ? 'bg-dark border-secondary' : 'bg-white'">
                  <div class="card-header py-2"
                    :class="$store.getters.getDarkMode ? 'bg-dark border-secondary' : 'bg-light'">
                    <h6 class="mb-0" :class="$store.getters.getDarkMode ? 'text-light' : 'text-dark'">
                      <i class="fas fa-filter me-2"></i>
                      Filtros de Búsqueda
                    </h6>
                  </div>
                  <div class="card-body py-3">
                    <div class="row">
                      <!-- Filtro Placa -->
                      <div class="col-md-6 col-lg-2">
                        <label class="form-label small mb-1"
                          :class="$store.getters.getDarkMode ? 'text-light' : 'text-dark'">
                          <i class="fas fa-id-card me-1"></i>
                          Placa
                        </label>
                        <input type="text" class="form-control form-control-sm" v-model="filtros.placa"
                          @keyup="getIndex()" placeholder="Buscar placa..." />
                      </div>

                      <!-- Filtro Tipo de Carrocería -->
                      <div class="col-md-6 col-lg-2">
                        <label class="form-label small mb-1"
                          :class="$store.getters.getDarkMode ? 'text-light' : 'text-dark'">
                          <i class="fas fa-truck me-1"></i>
                          Tipo
                        </label>
                        <select class="form-control form-control-sm" v-model="filtros.tipoCarroceria"
                          @change="getIndex()">
                          <option value="">Todos...</option>
                          <option v-for="tipoCarroceria in listasForms.tiposCarrocerias"
                            :key="tipoCarroceria.numeracion" :value="tipoCarroceria.numeracion">
                            {{ tipoCarroceria.descripcion }}
                          </option>
                        </select>
                      </div>

                      <!-- Filtro Modelo -->
                      <div class="col-md-6 col-lg-2">
                        <label class="form-label small mb-1"
                          :class="$store.getters.getDarkMode ? 'text-light' : 'text-dark'">
                          <i class="fas fa-calendar me-1"></i>
                          Modelo
                        </label>
                        <input type="text" class="form-control form-control-sm" v-model="filtros.modelo"
                          @keyup="getIndex()" placeholder="Buscar modelo..." />
                      </div>

                      <!-- Filtro Estado -->
                      <div class="col-md-6 col-lg-2">
                        <label class="form-label small mb-1"
                          :class="$store.getters.getDarkMode ? 'text-light' : 'text-dark'">
                          <i class="fas fa-toggle-on me-1"></i>
                          Estado
                        </label>
                        <select class="form-control form-control-sm" v-model="filtros.estado" @change="getIndex()">
                          <option value="">Todos...</option>
                          <option v-for="estado in listasForms.estados" :key="estado.numeracion"
                            :value="estado.numeracion">
                            {{ estado.descripcion }}
                          </option>
                        </select>
                      </div>

                      <!-- Filtro Líneas de Negocio -->
                      <div class="col-md-6 col-lg-3">
                        <label class="form-label small mb-1"
                          :class="$store.getters.getDarkMode ? 'text-light' : 'text-dark'">
                          <i class="fas fa-briefcase me-1"></i>
                          Líneas de Negocio
                        </label>
                        <v-select :class="$store.getters.getDarkMode ? 'dark-vselect' : ''" v-model="linea_negocio"
                          label="nombre" class="form-control form-control-sm p-0" :options="listasForms.lineasNegocios"
                          :filterable="true" multiple @input="getIndex()" placeholder="Seleccionar..."></v-select>
                      </div>

                      <!-- Filtro Empresa -->
                      <div class="col-md-6 col-lg-3">
                        <label class="form-label small mb-1"
                          :class="$store.getters.getDarkMode ? 'text-light' : 'text-dark'">
                          <i class="fas fa-building me-1"></i>
                          Empresa
                        </label>
                        <v-select :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                          v-model="listasForms.selct_empresa" placeholder="Buscar empresa..." label="razon_social"
                          class="form-control form-control-sm p-0" :options="empresas" :filterable="false"
                          @search="buscarEmpresas" @input="getIndex()"></v-select>
                      </div>

                      <!-- Botón limpiar filtros -->
                      <div class="col-md-12 col-lg-2 d-flex align-items-end">
                        <button type="button" class="btn btn-outline-secondary btn-sm w-100" @click="limpiarFiltros()">
                          <i class="fas fa-eraser me-1"></i>
                          Limpiar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Contenido principal - Solo Tabla -->
            <div class="card" :class="$store.getters.getDarkMode ? 'bg-dark border-secondary' : 'bg-white'">
              <div class="card-header py-2"
                :class="$store.getters.getDarkMode ? 'bg-dark border-secondary' : 'bg-light'">
                <div class="d-flex justify-content-between align-items-center">
                  <h6 class="mb-0" :class="$store.getters.getDarkMode ? 'text-light' : 'text-dark'">
                    <i class="fas fa-table me-2"></i>
                    Lista de Remolques
                  </h6>
                  <span class="badge bg-primary">
                    {{ remolques.total || 0 }} registros
                  </span>
                </div>
              </div>

              <div class="card-body p-0">
                <div class="table-responsive">
                  <table class="table table-hover table-striped mb-0"
                    :class="$store.getters.getDarkMode ? 'table-dark' : ''">
                    <thead :class="$store.getters.getDarkMode ? 'table-dark' : 'table-light'">
                      <tr>
                        <th class="text-center" style="width: 80px;">
                          <i class="fas fa-image"></i>
                        </th>
                        <th>
                          <i class="fas fa-id-card me-1"></i>
                          Placa
                        </th>
                        <th>
                          <i class="fas fa-truck me-1"></i>
                          Tipo
                        </th>
                        <th>
                          <i class="fas fa-calendar me-1"></i>
                          Modelo
                        </th>
                        <th class="text-center">
                          <i class="fas fa-toggle-on me-1"></i>
                          Estado
                        </th>
                        <th>
                          <i class="fas fa-briefcase me-1"></i>
                          Líneas
                        </th>
                        <th>
                          <i class="fas fa-building me-1"></i>
                          Empresa
                        </th>
                        <th>
                          <i class="fas fa-file-alt me-1"></i>
                          Documentos
                        </th>
                        <th class="text-center" style="width: 120px;">
                          <i class="fas fa-cogs me-1"></i>
                          Acciones
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="remolque in remolques.data" :key="remolque.id">
                        <td class="text-center">
                          <a v-if="remolque.link_fotografia" :href="uri_docs + remolque.link_fotografia" target="_blank"
                            class="d-inline-block">
                            <img :src="uri_docs + remolque.link_fotografia" alt="Remolque" class="rounded shadow-sm"
                              style="width: 50px; height: 50px; object-fit: cover;" />
                          </a>
                          <div v-else class="d-flex align-items-center justify-content-center rounded"
                            :class="$store.getters.getDarkMode ? 'bg-secondary' : 'bg-light'"
                            style="width: 50px; height: 50px; margin: 0 auto;">
                            <i class="fas fa-truck text-muted"></i>
                          </div>
                        </td>
                        <td>

                          {{ remolque.placa }}

                        </td>
                        <td>

                          {{ remolque.nTipoTipoCarroceria }}

                        </td>
                        <td>

                          {{ remolque.modelo }}

                        </td>
                        <td class="text-center">
                          <span class="badge" data-toggle="modal" data-target="#modal-form-estado"
                            style="cursor: pointer" v-bind:class="[remolque.estado == 1 ? 'bg-success' : 'bg-danger']"
                            @click="llenarModal(remolque.id, remolque.estado)">
                            {{ remolque.estado == 1 ? "ACTIVO" : "INACTIVO" }}
                          </span>
                        </td>
                        <td>
                          <div v-if="remolque.lineas_negocio && remolque.lineas_negocio.length > 0"
                            class="d-flex flex-column gap-6">
                            <span v-for="linea in remolque.lineas_negocio" :key="linea.id" class="badge bg-navy  ">
                              {{ linea.nombre }}
                            </span>
                          </div>
                          <span v-else class="text-muted small">Sin líneas</span>
                        </td>
                        <td>
                          <span :class="$store.getters.getDarkMode ? 'text-light' : 'text-dark'">
                            {{ remolque.empresa ? remolque.empresa.razon_social : "No encontrada" }}
                          </span>
                        </td>
                        <td>
                          <div class="d-flex flex-column gap-1">
                            <span v-if="remolque.documentos_vencidos.length > 0" class="badge bg-danger">
                              <i class="fas fa-exclamation-triangle me-1"></i>
                              Vencidos ({{ remolque.documentos_vencidos.length }})
                            </span>
                            <span v-if="remolque.paquetes.length <= 0" class="badge bg-danger">
                              <i class="fas fa-times me-1"></i>
                              Sin paquete
                            </span>
                            <span v-if="remolque.documentos_pendientes.length > 0" class="badge bg-warning">
                              <i class="fas fa-clock me-1"></i>
                              Pendientes ({{ remolque.documentos_pendientes.length }})
                            </span>
                            <span v-if="remolque.documentos_no_verificados.length > 0" class="badge bg-info">
                              <i class="fas fa-question me-1"></i>
                              No verificados ({{ remolque.documentos_no_verificados.length }})
                            </span>
                            <span v-if="
                              remolque.documentos_vencidos.length === 0 &&
                              remolque.documentos_pendientes.length === 0 &&
                              remolque.documentos_no_verificados.length === 0 &&
                              remolque.paquetes.length > 0
                            " class="badge bg-success">
                              <i class="fas fa-check me-1"></i>
                              Verificado
                            </span>
                          </div>
                        </td>
                        <td class="text-center">
                          <div class="btn-group btn-group-sm" role="group">
                            <button type="button" class="btn btn-outline-primary"
                              v-if="$store.getters.can('admin.remolques.editarTransportadora') && !admin"
                              @click="edit(remolque, 3)" title="Editar">
                              <i class="fas fa-edit"></i>
                            </button>
                            <button type="button" class="btn btn-outline-info"
                              v-else-if="$store.getters.can('admin.remolques.show')" @click="edit(remolque, 1)"
                              title="Ver detalles">
                              <i class="fas fa-eye"></i>
                            </button>
                            <button type="button" class="btn btn-outline-primary"
                              v-if="empresa.length > 0 && remolque.tipo_propiedad == 1 && remolque.empresa_id && empresa[0].id == remolque.empresa_id && $store.getters.can('admin.remolques.edit')"
                              @click="edit(remolque, 2)" title="Editar">
                              <i class="fas fa-edit"></i>
                            </button>
                            <button type="button" class="btn btn-outline-primary"
                              v-else-if="(empresa.length === 0 || remolque.tipo_propiedad != 1) && $store.getters.can('admin.remolques.edit')"
                              @click="edit(remolque, 2)" title="Editar">
                              <i class="fas fa-edit"></i>
                            </button>
                            <button type="button" class="btn btn-outline-secondary"
                              v-if="$store.getters.can('admin.remolques.show')"
                              @click="llenarModalHistorial('App\\Remolque', remolque.id)" title="Ver historial">
                              <i class="fas fa-history"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Mensaje cuando no hay datos -->
                <div v-if="!remolques.data || remolques.data.length === 0" class="text-center py-5">
                  <h5 class="text-muted">No hay remolques para mostrar</h5>
                  
                  <div class="text-center py-4">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Cargando...</span>
                    </div>
                    <p class="mt-2 text-muted">Cargando Remolques..</p>
                  </div>
                </div>
              </div>
              <div class="card-footer border-0"
                :class="$store.getters.getDarkMode ? 'bg-dark border-secondary' : 'bg-light'">
                <div class="d-flex justify-content-between align-items-center">
                  <div v-if="remolques.total">
                    <p class="mb-0 small text-muted">
                      Mostrando del <span class="fw-bold text-primary">{{ remolques.from }}</span> al
                      <span class="fw-bold text-primary">{{ remolques.to }}</span> de un total de
                      <span class="fw-bold text-primary">{{ remolques.total }}</span> registros
                    </p>
                  </div>
                  <div v-else>

                    <span class="badge bg-danger">
                      No hay registros para mostrar
                    </span>
                  </div>
                  <pagination :data="remolques" @pagination-change-page="getIndex" :limit="5" align="right">
                  </pagination>
                </div>
              </div>
            </div>
          </div>
        </section>
        <RemolqueEstado ref="RemolqueEstado" />
        <HistorialEstado ref="HistorialEstado" />
      </div>
    </div>
    <RemolqueExport ref="RemolqueExport" />
  </div>
</template>

<script>
import axios from "axios";
import pagination from "laravel-vue-pagination";
import RemolqueEstado from "./RemolqueEstado";
import RemolqueExport from "./RemolqueExport";
import HistorialEstado from "../../../admin/basico/historialEstado/HistorialEstado";
import vSelect from "vue-select";
export default {
  name: "RemolqueIndex",
  components: {
    pagination,
    RemolqueEstado,
    RemolqueExport,
    HistorialEstado,
    vSelect,
  },
  data() {
    return {
      empresa: this.$store.getters.getUser.empresas,
      linea_negocio: [],
      empresas: [],
      user: null,
      admin: null,
      filtros: {
        lineaNegocio: null,
        placa: null,
        tipoCarroceria: null,
        modelo: null,
        estado: null,
        empresa_id: null,
      },
      remolques: {},
      listasForms: {
        lineasNegocios: [],
        tiposCarrocerias: [],
        estados: [],
        selct_empresa: [],
      },
      uri_docs: process.env.VUE_APP_AWS_BUCKET_URL,
    };
  },
  validations: {},
  methods: {
    getIndex(page = 1) {
      this.filtros.lineaNegocio = [];
      this.filtros.empresa_id = null;
      this.remolques = {};
      this.linea_negocio.forEach((linea) => {
        this.filtros.lineaNegocio.push(linea.id);
      });
      if (this.listasForms.selct_empresa) {
        this.filtros.empresa_id = this.listasForms.selct_empresa.id;
      }
      axios
        .get("/api/admin/remolques?page=" + page, {
          params: this.filtros,
        })
        .then((response) => {
          this.remolques = response.data;
        });

      if (this.$store.state.user) {
        const administrador = this.$store.state.user.roles.find(
          (administrador) => administrador.id === 1,
        );
        if (administrador) {
          this.admin = administrador.id;
        }
      }
    },

    getLineasNegocios() {
      axios.get("/api/admin/lineasNegocios/lista").then((response) => {
        this.listasForms.lineasNegocios = response.data;
      });
    },

    getTiposCarrocerias() {
      axios.get("/api/lista/9").then((response) => {
        this.listasForms.tiposCarrocerias = response.data;
      });
    },

    getEstados() {
      axios.get("/api/lista/1").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    buscarEmpresas(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/admin/empresas/lista?razon=" + search;
        axios
          .get(url)
          .then(function (response) {
            let respuesta = response.data;
            me.empresas = respuesta;
            loading(false);
          })
          .catch(function (error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    destroy(idRemolque) {
      this.$swal({
        title: "Esta seguro de eliminar este Item?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Eliminar!",
      }).then((result) => {
        if (result.value) {
          axios
            .delete("/api/admin/remolques/" + idRemolque)
            .then((response) => {
              this.getIndex();
              this.$swal({
                icon: "success",
                title: "Se elimino el remolque exitosamente...",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            });
        }
      });
    },

    create() {
      return this.$router.push({
        name: "/Admin/RemolqueForm",
        params: { accion: "Crear", id: 0 },
      });
    },

    edit(remolque, opcion) {
      return this.$router.push({
        name: "/Admin/RemolqueForm",
        params: {
          accion: "Editar",
          data_edit: remolque,
          id: remolque.id,
          opcion: opcion,
        },
      });
    },
    pivotTable() {
      return this.$router.push({
        name: "/Admin/RemolquePivotTable",
      });
    },

    llenarModal(id, estado) {
      if (this.$store.getters.can("admin.remolques.editStatus")) {
        this.$refs.RemolqueEstado.llenar_modal(id, estado);
      }
    },

    llenarModalHistorial(entidad, entidad_id) {
      if (this.$store.getters.can("admin.remolques.show")) {
        this.$refs.HistorialEstado.llenar_modal(entidad, entidad_id);
      }
    },

    generarListadoExcel() {
      this.$parent.cargando = true;

      axios({
        method: "POST",
        url: "/api/admin/remolques/export",
        data: this.form,
      })
        .then((response) => {
          let data = response.data;
          this.$parent.cargando = false;
          location.href = data.url;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.$parent.cargando = false;
        });
    },

    limpiarFiltros() {
      this.filtros = {
        lineaNegocio: null,
        placa: null,
        tipoCarroceria: null,
        modelo: null,
        estado: null,
        empresa_id: null,
      };
      this.linea_negocio = [];
      this.listasForms.selct_empresa = null;
      this.getIndex();
    },
  },
  mounted() {
    this.getIndex();
    this.getLineasNegocios();
    this.getTiposCarrocerias();
    this.getEstados();
  },
};
</script>
